enum STATUS_STEPS {
  inProgress = 'IN_PROGRESS',
  completed = 'COMPLETED',
  rejected = 'REJECTED',
}

export const handleStatusStep = ({
  status,
  startAt,
  endAt,
}: {
  status?: string;
  startAt?: string;
  endAt?: string;
}) => {
  if (status === STATUS_STEPS.completed) {
    return { status: 'COMPLETED', dateStr: endAt ?? startAt };
  } else if (status === STATUS_STEPS.inProgress) {
    return { status: 'IN_PROGRESS', dateStr: startAt };
  } else if (status === STATUS_STEPS.rejected) {
    return { status: 'REJECTED', dateStr: endAt ?? startAt };
  }
  return { status: '', dateStr: '' };
};
